export default __webpack_public_path__ + "static/media/pdf-icon.f7f4aa8b.png";